import AgencyClientDetails from "./Details"
import AgencyClientsList from "./List"
import { AuthorizedRoute } from "components/AuthorizedRoute"
import { Switch } from "react-router-dom"

export default function AgencyClients() {
  const basePath = `/agency-clients`

  return (
    <Switch>
      <AuthorizedRoute
        allowed={["AUTH_VIEW_AGENCY_CLIENT"]}
        path={`${basePath}/:id/:tab?/:configId?`}
        component={AgencyClientDetails}
      />
      <AuthorizedRoute
        allowed={["AUTH_VIEW_AGENCY_CLIENT"]}
        component={AgencyClientsList}
      />
    </Switch>
  )
}
